import React from 'react';
import {
  Container,
  Typography,
  Box,
  Breadcrumbs,
  Link as MuiLink,
  IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CustomerManagementTab from './tabs/CustomerManagementTab';

const CustomerManagementView: React.FC = () => {
  const navigate = useNavigate();

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Breadcrumbs Navigation */}
      <Breadcrumbs aria-label="Navigationspfad" sx={{ mb: 2 }}>
        <MuiLink
          color="inherit"
          component="button"
          variant="body1"
          onClick={() => navigate('/dashboard')}
          sx={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          Dashboard
        </MuiLink>
        <MuiLink
          color="inherit"
          component="button"
          variant="body1"
          onClick={() => navigate('/backoffice')}
          sx={{ textDecoration: 'none', cursor: 'pointer' }}
        >
          Administration
        </MuiLink>
        <Typography color="text.primary">Kundenanfragen</Typography>
      </Breadcrumbs>

      {/* Header */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 4 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton
            sx={{ mr: 2 }}
            onClick={() => navigate('/backoffice')}
            aria-label="Zurück zur Administration"
          >
            <ArrowBackIcon />
          </IconButton>
          <Typography variant="h4" component="h1">
            Kundenanfragen-Management
          </Typography>
        </Box>
      </Box>
      
      {/* Content */}
      <CustomerManagementTab />
    </Container>
  );
};

export default CustomerManagementView; 